import Image from "next/image"

const NoRecord = () => {
  return (
    <>
      <div className="text-center col-span-3 mt-50">
        <Image
          src="/img/error_graphic_one.png"
          alt="loading"
          width="100"
          height="100"
          loading="lazy"
        />
        <p className="fw-600 mb-0">No records found!</p>
      </div>
    </>
  )
}

export default NoRecord
